export default "__VITE_ASSET__b418ec77__"